/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type ExecuteResultKind = typeof ExecuteResultKind[keyof typeof ExecuteResultKind];


export const ExecuteResultKind = {
  sent_now: 'sent_now',
  scheduled: 'scheduled',
  queued: 'queued',
} as const;
